import axios from "axios";

const customAxios = axios.create();
customAxios.interceptors.request.use(
  config => config,
  error => Promise.reject(error)
);
customAxios.interceptors.response.use(
  response => Promise.resolve(response),
  error => {
    if (error.response) {
      const expired = error.response.headers?.["x-impersonation-expired"] === "true"
        || error.response.data?.errors?.[0]?.detail === "impersonation_expired"
      if (error.response.status === 401 && expired) {
        window.location.assign("/")
        return Promise.resolve(null)
      }
      if (error.response.status === 401) {
        window.location.href = "/logout";
        return Promise.resolve(null)
      }
    }
    return Promise.reject(error);
  }
);

export default customAxios;
